// @flow

import React from "react";
import classNames from "classnames";

import options from "../utils/options";
import TextArrayWidget from "./text-array";
import type { SchemaTableWidgetProps } from "../types";

import styles from "./custom-answer-type-switch.scss";

export class CustomAnswerTypeSwitch extends React.Component<SchemaTableWidgetProps<Array<string>>> {
  render() {
    const disabled = options.resolveBoolean((this.props.options || {}).disabled, this.props.row);

    if (!this.props.active) {
      const data = this.props.data;
      return (
        <div
          className={classNames("custom-answer-type-switch__readonly", {
            "custom-answer-type-switch__disabled": disabled,
          })}
        >
          {data && data.join ? data.join("; ") : data}
        </div>
      );
    }

    switch ((this.props.row || {}).questionType) {
      case "SINGLE_SELECT":
      case "MULTI_SELECT":
        return <TextArrayWidget {...this.props} />;
      case "FREE_TEXT":
      case "DATE_PICK":
      case "CONFIRMATION":
      default:
        return (
          <div
            className={classNames("custom-answer-type-switch__readonly", {
              "custom-answer-type-switch__disabled": disabled,
            })}
          >
            - Free entry answer -
          </div>
        );
    }
  }
}

export default CustomAnswerTypeSwitch;
